module.exports = __webpack_public_path__ + "static/media/health-safety-measures_filter.2ea2b82a.svg";